import { animated, useSpring } from '@react-spring/web';

export function FadeIn({ props, children, visible = true, duration = 1000 }) {
  const styles = useSpring({
    ...props,
    config: { duration },
  });

  return visible && <animated.div style={styles}>{children}</animated.div>;
}
